import { RichText } from "@wordpress/block-editor";
import { BlockSaveProps } from "@wordpress/blocks";
import React from "react";
import { Element } from "../../components";
import IconRenderer from "../../components/common/IconRenderer";
import { cn } from "../../utils";

const Save: React.ComponentType<BlockSaveProps<any>> = (props) => {
	const {
		attributes: {
			clientId,
			text,
			className,
			cssID,
			link,
			size,
			style,
			icon,
			iconPosition,
			blockHTML,
			buttonAnimation,
			typography,
		},
	} = props;

	const Wrapper = blockHTML ?? "div";

	return (
		<Wrapper
			id={cssID ?? undefined}
			className={cn(`mzb-button mzb-button-${clientId} `, className)}
			data-aos={
				buttonAnimation && "none" !== buttonAnimation
					? buttonAnimation
					: undefined
			}
		>
			<Element
				tagName="a"
				htmlAttrs={{
					className: cn(
						"mzb-button-link",
						size && `is-${size}`,
						style && `is-style-${style}`,
						typography?._className
					),
					href: link && link.url ? link.url : null,
					target: link && link.newTab ? "_blank" : null,
					rel: link && link.newTab ? "noopener" : null,
				}}
			>
				{icon &&
					"" !== icon.icon &&
					icon.enable &&
					"left" === iconPosition && (
						<span className="mzb-button-icon">
							<IconRenderer name={icon.icon} />
						</span>
					)}
				<RichText.Content value={text} />
				{icon &&
					"" !== icon.icon &&
					icon.enable &&
					"right" === iconPosition && (
						<span className="mzb-button-icon">
							<IconRenderer name={icon.icon} />
						</span>
					)}
			</Element>
		</Wrapper>
	);
};

export default Save;
